// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3aQPp","info":"Note_info__17NB1","note":"Note_note__298U2","actions":"Note_actions__2FcNP"};